import { render, staticRenderFns } from "./MerchantsList.vue?vue&type=template&id=1d0e1698&scoped=true&"
import script from "./MerchantsList.vue?vue&type=script&lang=js&"
export * from "./MerchantsList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d0e1698",
  null
  
)

export default component.exports